import { render, staticRenderFns } from "./horizontal_cell.vue?vue&type=template&id=072230e1&scoped=true"
import script from "./horizontal_cell.vue?vue&type=script&lang=js"
export * from "./horizontal_cell.vue?vue&type=script&lang=js"
import style0 from "./horizontal_cell.vue?vue&type=style&index=0&id=072230e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072230e1",
  null
  
)

export default component.exports